import { Control, Controller, FieldValues, UseFormWatch } from 'react-hook-form';

import { CheckMark } from 'components/CheckMark';

import { useCheckboxWithControl } from './CheckboxWithControl.hooks';
import { StyledCheckboxProps } from './CheckboxWithControl.styles';
import * as S from './CheckboxWithControl.styles';

type CheckboxProps = {
  name: string;
  label: string;
  control: Control;
  defaultChecked?: boolean;
  reset?: (values: {}) => void;
  onCheck?: (arg: React.ChangeEvent<HTMLInputElement>, name?: string) => void;
  watch?: UseFormWatch<FieldValues>;
} & StyledCheckboxProps;

const defaultProps: Partial<CheckboxProps> = {
  name: undefined,
  defaultChecked: false,
  isCheckIcon: false,
  hasBorderContainer: false,
  margin: undefined,
  disabled: false,
  reset: undefined,
  onCheck: undefined,
};

export function CheckboxWithControl(props: CheckboxProps): React.ReactElement {
  const {
    name,
    label,
    control,
    defaultChecked,
    isCheckIcon,
    hasBorderContainer,
    margin,
    disabled,
    onCheck,
    watch,
  } = {
    ...defaultProps,
    ...props,
  };

  const { isChecked, isCheckedSet } = useCheckboxWithControl(
    name,
    control,
    defaultChecked,
    onCheck,
    watch
  );

  return (
    <S.Wrapper margin={margin} isPermissions={isCheckIcon && hasBorderContainer}>
      <S.ItemWrapper disabled={disabled} hasBorderContainer={hasBorderContainer} key={name}>
        <Controller
          control={control}
          name={name}
          render={({ field: { onChange } }) => (
            <S.InputWrapper>
              <S.Checkbox
                key={`${name}-${label}`}
                type="checkbox"
                onChange={(e) => {
                  onChange(e.target.checked);
                  isCheckedSet(e.target.checked);
                  if (onCheck) {
                    onCheck(e, name);
                  }
                }}
                isCheckIcon={isCheckIcon}
                checked={isChecked}
              />

              {isCheckIcon ? <CheckMark disabled={disabled} isChecked={isChecked} /> : null}
            </S.InputWrapper>
          )}
        />

        <S.ItemLabel disabled={disabled}>{label}</S.ItemLabel>
      </S.ItemWrapper>
    </S.Wrapper>
  );
}
